import apiConfig from 'constants/apiConfig';
import { Country, CountryListResponse } from 'types/country';
import axiosClient from 'utils/axiosClient';

export const fetchCountries = async (): Promise<Country[]> => {
    const response = await axiosClient.get<CountryListResponse>(apiConfig.COUNTRY.url);
    return response.data?.items ?? [];
};
